<template>
  <div class="card-content">
    <div class="card-body">
      <div class="media d-flex">
        <div class="media-body">
          <h5 class="card-title skokka-text">
            <i class="float-left mr-2"> Testers Buttons: </i>
          </h5>
          <br />
          <br />
          <h5 class="card-title skokka-text">
            <i class="float-left mr-2"> YOTI </i>
          </h5>
          <br />
          <button
            type="button"
            class="btn btn-primary"
            @click="changeVerificationStatus(2)"
          >
            + Profile Pending Yoti
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="changeVerificationStatus(3)"
          >
            + Profile Verified Yoti
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="changeVerificationStatus(1)"
          >
            + Profile Rejected Yoti
          </button>
          <div v-if="isProfileYotiVerificationCompleted">
            <h5 class="card-title skokka-text">
              <br />
              <br />
              <i class="float-left mr-2"> 360 VIDEO </i>
            </h5>
            <br />
            <button
              v-if="canHandle360Video"
              type="button"
              class="btn btn-primary"
              @click="moderateVideo360Status('not_requested')"
            >
              - Remove Video 360
            </button>
            <button
              v-if="canHandle360Video"
              type="button"
              class="btn btn-primary"
              @click="moderateVideo360Status('pending')"
            >
              - Reset Video 360 to pending
            </button>
            <button
              v-if="canHandle360Video"
              type="button"
              class="btn btn-primary"
              @click="moderateVideo360Status('not_allowed')"
            >
              - Reject Video 360
            </button>
            <button
              v-if="canHandle360Video"
              type="button"
              class="btn btn-primary"
              @click="moderateVideo360Status('allowed')"
            >
              + Approve Video 360
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import changeYotiVerificationStatus from '../../js/utils/api_calls'

  export default {
    name: 'TesterProfileVerificationsActionButtons',
    props: {
      changeVerificationStatusUrl: {
        type: String,
        required: true,
      },
      moderateVideo360StatusUrl: {
        type: String,
        required: true,
      },
      profileSteps: {
        type: Array,
        required: true,
        default: () => [],
      },
      canHandle360Video: {
        type: Boolean,
        required: true,
        default: false,
      },
    },
    data() {
      return {}
    },
    computed: {
      isProfileYotiVerificationCompleted() {
        const yotiStep = this.profileSteps.find((step) => step.code === 'verify_your_age')
        return yotiStep?.class_status === 'completed'
      },
    },
    methods: {
      async changeVerificationStatus(status) {
        await changeYotiVerificationStatus(status, this.changeVerificationStatusUrl)
      },
      async moderateVideo360Status(status) {
        const requestBody = {
          video_360_status: status,
        }
        const headers = {
          headers: {
            'X-CSRFToken': this.$cookies.get('csrftoken'),
          },
        }
        try {
          const response = await this.$http.post(
            this.moderateVideo360StatusUrl,
            requestBody,
            headers
          )
          if (response.status === 200) {
            window.location.reload()
          } else {
            throw new Error(response.data.data.message)
          }
        } catch (error) {
          window.showErrorTopAlertWithTimer()
        }
      },
    },
  }
</script>
